"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractToken_1 = require("./AbstractToken");
var DeviceToken = /** @class */ (function (_super) {
    __extends(DeviceToken, _super);
    function DeviceToken(encodedToken, rawToken) {
        var _this = _super.call(this, encodedToken, rawToken) || this;
        _this.getDeviceId = function () {
            return _this.encodeCustomClaims()['x-uninow-device-id'] || 'sdsd';
        };
        _this.getUserId = function () {
            return _this.encodeCustomClaims()['x-uninow-user-id'];
        };
        _this.getDefaultProfile = function () {
            return _this.encodeCustomClaims()['x-uninow-default-profile'];
        };
        _this.getAllowedProfiles = function () {
            var profiles = [];
            if (_this.encodeCustomClaims()["x-uninow-allowed-profiles"].length > 0) {
                _this.encodeCustomClaims()["x-uninow-allowed-profiles"].forEach(function (e) {
                    if (e) {
                        profiles.push(e);
                    }
                });
            }
            return new Set(profiles);
        };
        _this.getUniNowClaims = function () {
            return {
                defaultProfile: _this.getDefaultProfile(),
                allowedProfiles: _this.getAllowedProfiles(),
                deviceId: _this.getDeviceId()
            };
        };
        _this.encodeCustomClaims = function () {
            var jsonClaims = JSON.stringify(_this._encodedToken.claims['https://uninow.com/jwt/claims']);
            return JSON.parse(jsonClaims);
        };
        return _this;
    }
    return DeviceToken;
}(AbstractToken_1.AbstractToken));
exports.DeviceToken = DeviceToken;
